import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SalesOrderPurchaseAllocation } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderPurchaseAllocationService extends TmsWebBaseEditCreateService<
  SalesOrderPurchaseAllocation,
  SalesOrderPurchaseAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderPurchaseAllocation', $localize`Sales Order Purchase Allocation`);
  }

  allocate(salesOrderLineId: string, purchaseOrderLineId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      salesOrderLineId,
      purchaseOrderLineId,
    });
  }

  updateSalesOrderPurchaseAllocation(salesOrderPurchaseAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateSalesOrderPurchaseAllocation`, {
      salesOrderPurchaseAllocationId,
      quantity,
    });
  }

  getAllocations(salesOrderLineId: any): Observable<SalesOrderPurchaseAllocation[]> {
    return this.httpService.get<SalesOrderPurchaseAllocation[]>(
      `${this.apiUrl}/GetAllocations?salesOrderLineId=${salesOrderLineId}`,
    );
  }
}
